import { useContext } from 'react';
import { AuthContext } from './AuthContextCore';
import type { AuthContextType } from './AuthTypes';

// Extended type that includes the isAuthenticated property
type ExtendedAuthContextType = AuthContextType & {
  isAuthenticated: boolean;
};

export const useAuth = (): ExtendedAuthContextType => {
  const context = useContext(AuthContext);
  
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  
  // Add isAuthenticated property based on user existence
  return {
    ...context,
    isAuthenticated: !!context.user
  };
};
